export default "__VITE_ASSET__24Fo8K04__"